/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConnectionTestResult
 */
export interface ConnectionTestResult {
    /**
     * 是否连接成功
     * @type {boolean}
     * @memberof ConnectionTestResult
     */
    success?: boolean;
    /**
     * 失败分类，成功时为空
     * @type {string}
     * @memberof ConnectionTestResult
     */
    errorType?: string;
    /**
     * 已脱敏的失败提示，成功时为空
     * @type {string}
     * @memberof ConnectionTestResult
     */
    message?: string;
}

/**
 * Check if a given object implements the ConnectionTestResult interface.
 */
export function instanceOfConnectionTestResult(value: object): value is ConnectionTestResult {
    return true;
}

export function ConnectionTestResultFromJSON(json: any): ConnectionTestResult {
    return ConnectionTestResultFromJSONTyped(json, false);
}

export function ConnectionTestResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConnectionTestResult {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'errorType': json['errorType'] == null ? undefined : json['errorType'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function ConnectionTestResultToJSON(json: any): ConnectionTestResult {
    return ConnectionTestResultToJSONTyped(json, false);
}

export function ConnectionTestResultToJSONTyped(value?: ConnectionTestResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'errorType': value['errorType'],
        'message': value['message'],
    };
}

